<template>
  <div style="width: 100%; height: 100%; padding-left: 252px">
    <v-card style="height: 100%" elevation="0">
      <v-card-title class="pt-5" style="margin-top: -2px; margin-bottom: 2px"> 应用授权 </v-card-title>
      <v-toolbar flat>
        <v-btn-toggle v-model="btnValue" @change="btnGroupClick" dense group mandatory color="primary" class="ml-n2">
          <v-btn :value="bi.key" class="ml-2" v-for="(bi, index) in btnGroup" :key="index">{{ bi.val }}</v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <div style="width: 300px">
          <v-text-field @keyup.enter="areaQuery" @click:append="areaQuery" v-model="queryParam.condition" placeholder="名称/描述" class="pt-5" append-icon="mdi-magnify" outlined dense></v-text-field>
        </div>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pt-0" style="height: calc(100% - 121px)">
        <v-row class="vtk-height">
          <v-col md="4" class="pb-0 mt-4">
            <v-card class="vtk-height d-flex" :class="$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-4'" elevation="0">
              <div class=" ma-auto">
                <v-img class="mx-auto" max-width="220" :src="require('@/assets/img/noData.png')"></v-img>
                <p class="text-center grey--text">应用开发中尽请期待...</p>
              </div>
            </v-card>
          </v-col>
          <v-col md="8" class="pb-0 mt-4">
            <v-card class="vtk-height d-flex" :class="$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-4'" elevation="0">
              <div class="ma-auto">
                <v-img class="mx-auto" max-width="220" :src="require('@/assets/img/noData.png')"></v-img>
                <p class="text-center grey--text">应用开发中尽请期待...</p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// import Request from "@/commons/request";
// import Storage from "@/commons/storage";
export default {
  props: {
    appsd: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    btnGroup: [
      { key: "0", val: "全部" },
      { key: "2", val: "省级" },
      { key: "4", val: "市级" },
      { key: "6", val: "区县" },
      { key: "9", val: "街镇" },
      { key: "12", val: "村社" },
    ],
    btnValue: "0",
    queryParam: {},
    entity: {},
    user: {},
  }),
  mounted() {
    this.areaQuery();
  },
  watch: {
    $route(to, from) {
      if (to.query.aid && to.query.aid != from.query.aid) {
        this.areaQuery();
      }
    },
  },
  methods: {
    areaQuery() {
      this.queryParam.aid = this.$route.query.aid;
    },
    btnGroupClick() {
      this.queryParam.leve = this.btnValue;
      this.areaQuery();
    },
  },
};
</script>